<!-- DME IQ 远程协助栏 -->
<div *ngIf="isShow" class="remote-assistance-container">
    <div class="remote-assistance-content">
        <div class="remote-assistance-content-icon-and-title">
            <svg class="icon">
                <use xlink:href="#core-icon-simple-status-failed"></use>
            </svg>
            <!-- 标题 -->
            <span class="remote-assistance-content-title ml-8">{{remoteAssistanceContentTitle}}</span>
        </div>
        <div class="ml-16">
            <!-- 勿操作提示 -->
            <span class="remote-assistance-content-tip ml-16">{{i18n.remoteAssistanceTitleTip}}</span>
            <!-- 剩余时间 -->
            <span class="remote-assistance-content-time" *ngIf="showLeftTime">{{remainingTime}}</span>
        </div>
    </div>
    <!-- 结束协助 -->
    <button nButton *ngIf="hasCallhomeW" class="remote-assistance-container-end-btn"
        id="remote-assistance-container-end-btn" [loading]="btnLoading"
        [label]="i18n.endBtn" (click)="endRemoteAssistance()">
    </button>
</div>

<!-- 申请 DME IQ 远程协助弹窗底部按钮 -->
<ng-template #applicationFooterBtn>
    <!-- 同意 -->
    <button nButton [label]="i18n.agreeBtn" theme="primary" id="remote-assistance-prompt-agree-btn"
        (click)="handleRemoteRequest(RemoteAssistanceTaskParamE.ACCEPT)">
    </button>
    <!-- 拒绝 -->
    <button nButton [label]="i18n.rejectBtn" id="remote-assistance-prompt-reject-btn"
        (click)="handleRemoteRequest(RemoteAssistanceTaskParamE.REJECT)">
    </button>
</ng-template>

<!-- 结束 DME IQ 远程协助弹窗底部按钮 -->
<ng-template #endFooterBtn>
    <!-- 确定 -->
    <button nButton theme="primary" id="remote-assistance-prompt-ok-btn"
    [label]="i18n.confirmBtn" (click)="handleRemoteRequest(RemoteAssistanceTaskParamE.TERMINATE)">
    </button>
    <!-- 取消 -->
    <button nButton id="remote-assistance-prompt-cancel-btn"
        [label]="i18n.cancelBtn" (click)="handleRemoteRequest()">
    </button>
</ng-template>
